import React from 'react';
import { TIconField, TIconFromRenderingParams } from '../../../types/types';
import iconData from './caseih.json';

export type TIconProps = {
  iconName?: string;
  iconField?: TIconField | TIconFromRenderingParams;
  color?: 'primary' | 'complement' | 'white' | 'error' | 'gray' | 'light-black' | 'success' | 'medium-gray' | 'warning';
  size?: number;
  extraClassName?: string;
  onClick?: () => void;
};

type TIconData = {
  webkitMaskUrl: string | null;
  alt: string | undefined;
};

const getIconDataFromKey: (iconName: string) => TIconData = (iconName) => {
  const icon = iconData?.items.find((iconItem) => iconName === iconItem?.title);

  if (icon) {
    return {
      webkitMaskUrl: typeof icon?.full === 'string' ? icon.full : null,
      alt: icon?.alt,
    };
  }

  return { webkitMaskUrl: null, alt: undefined };
};

const getIconDataromField: (iconField: TIconField | TIconFromRenderingParams | undefined) => TIconData = (iconField) => {
  const iconReferenceField = iconField as TIconField;
  const iconFromRenderingParams = iconField as TIconFromRenderingParams;

  if (iconReferenceField?.fields?.iconUrl?.value) {
    return { webkitMaskUrl: iconReferenceField.fields.iconUrl.value, alt: iconReferenceField.fields.iconAlt?.value };
  }

  if (iconFromRenderingParams?.iconUrl) {
    return { webkitMaskUrl: iconFromRenderingParams.iconUrl, alt: iconFromRenderingParams?.iconUrl };
  }

  return { webkitMaskUrl: null, alt: undefined };
};

const Icon = React.forwardRef<HTMLSpanElement, TIconProps>(function InnerIcon(
  { iconName, iconField, onClick, color = '', size, extraClassName = '' },
  ref
) {
  const { webkitMaskUrl, alt } = iconName ? getIconDataFromKey(iconName) : getIconDataromField(iconField);

  if (!webkitMaskUrl) {
    return null;
  }

  const iconStyles: React.CSSProperties = {
    WebkitMaskImage: `url(${webkitMaskUrl})`,
    WebkitMaskSize: 'cover',
    height: `${size || 16}px`,
    width: `${size || 16}px`,
  };

  return (
    <span ref={ref} className={`icon icon--${color} ${extraClassName}`} style={iconStyles} onClick={onClick} aria-label={alt} role="img" />
  );
});

export default React.memo(Icon);
